import React from "react";

const ErrorIcon = () => (
  <svg
    width="15"
    height="15"
    stroke="#EC0000"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.780273" width="14" height="14" rx="7" fill="white" />
    <path d="M7.78027 2V8" stroke="#EC0000" strokeWidth="1" />
    <circle cx="7.78027" cy="10.5" r="0.5" fill="#EC0000" stroke="#EC0000" />
  </svg>
);

export default ErrorIcon;
